module.exports = __webpack_public_path__ + "static/mstile-310x150-0970834a96284e5029ea6b64d3e0077e.png";